<template>
  <div class="emuInsert">
    <div class="form1">
    <el-form :inline="true" label-width="120px"> 
        <el-form-item label="Format" prop="ssformat1">
            <el-input type="textarea" v-model="ssformat1" :rows="3"  @change="ssFormat1"></el-input>
        </el-form-item>
        <el-form-item label="Format" prop="ssformat2">
            <el-input type="textarea" v-model="ssformat2" :rows="3" @change="ssFormat2"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="info" @click="openNewWindow('ssWebAddrMst')" round>网址关联</el-button>
            <el-button type="info" @click="openNewWindow('ssEmuLinkMst')" round>系统关联</el-button>
            <el-button type="info" @click="openNewWindow('ssEmuInNameCdMst')" round>模拟器CD保守</el-button>
            <el-button type="info" @click="openNewWindow('ssSystemCdMst')" round>系统CD保守</el-button><br>
        <template>
            <el-radio v-model="modRadio" label="1">常规模式</el-radio>
            <el-radio v-model="modRadio" label="2">模拟器模式</el-radio>
        </template>
        </el-form-item>
        
    </el-form>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px"
            :inline="true" class="demo-ruleForm" size="mini">
        <el-form-item label="主存ID" prop="ssid">
            <el-input v-model="ruleForm.ssid"></el-input>
        </el-form-item>
        <el-form-item label="资源地址" prop="ssaddr">
            <el-input v-model="ruleForm.ssaddr"></el-input>
        </el-form-item>
        <el-form-item label="资源提取码" prop="sskeyw">
            <el-input v-model="ruleForm.sskeyw"></el-input>
        </el-form-item>
        <el-form-item label="文件名" prop="ssfilenm">
            <el-input v-model="ruleForm.ssfilenm"></el-input>
        </el-form-item>
        <el-form-item label="文件路径" prop="ssfileroad">
            <el-input v-model="ruleForm.ssfileroad"></el-input>
        </el-form-item>
        <el-form-item label="文件MD5" prop="ssfilehach">
            <el-input v-model="ruleForm.ssfilehach"></el-input>
        </el-form-item>
        <el-form-item label="文件大小" prop="ssfilesize">
            <el-input v-model="ruleForm.ssfilesize"></el-input>
        </el-form-item>
        <el-form-item label="文件密码" prop="ssfilekeyw">
            <el-input v-model="ruleForm.ssfilekeyw"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="ssbk">
            <el-input v-model="ruleForm.ssbk"></el-input>
        </el-form-item>
        <el-form-item label="模拟器分支名" prop="ssemuname" v-show="modRadio==='2'">
            <el-input v-model="ruleForm.ssemuname"></el-input>
        </el-form-item>
        <el-form-item label="模拟器内部名CD" prop="ssemuinnamecd" v-show="modRadio==='2'">
            <el-input v-model="ruleForm.ssemuinnamecd"></el-input>
        </el-form-item>
        <el-form-item label="版本号" prop="ssver" v-show="modRadio==='2'">
            <el-input v-model="ruleForm.ssver"></el-input>
        </el-form-item>
        <el-form-item label="指向区分" prop="sspointkbn" v-show="modRadio==='1'">
            <el-input v-model="ruleForm.sspointkbn"></el-input>
        </el-form-item>
    </el-form>
    <el-form :inline="true"> 
        <el-form-item class="as_btn">
            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="btnFlag">保存本条  </el-button>
            <el-button type="primary" @click="addToTable('ruleForm')">查询</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
    </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%" size="mini" border>
        <el-table-column prop="ssid" label="SSID" width="180"> </el-table-column>
        <el-table-column prop="ssaddr" label="SSADDR" width="180"> </el-table-column>
        <el-table-column prop="sskeyw" label="SSKEYW"> </el-table-column>
        <el-table-column prop="ssfilenm" label="SSFILENM"> </el-table-column>
        ssfilenm
        <el-table-column label="操作">
            <template slot-scope="scope" width="180">
                <el-button size="mini"  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%">
        <span>主存ID存在！是否更新主存记录？</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false;btnFlag = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false;doupdate()">确 定</el-button>
        </span>
    </el-dialog>

    <el-dialog
        title="⚠警告"
        :visible.sync="dialogVisible2"
        width="30%">
        <span>刪除主存记录({{ row.ssid }})需要提供刪除序列號！</span>
        <el-form :inline="true" label-width="120px" ref="seq"> 
            <el-form-item label="序列號" prop="seq">
                <el-input v-model="ruleForm.seq"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible2 = false;">取 消</el-button>
            <el-button type="primary" @click="dialogVisible2 = false;dodelete()">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'emuInsert',
  data() {
    return {
        ssformat1:'',
        ssformat2:'',
        ruleForm: {
            ssid: '',
            ssaddr: '',
            sskeyw: '',
            ssfilenm: '',
            ssfileroad: '',
            ssfilehach:'',
            ssfilesize:'',
            ssfilekeyw:'',
            ssbk:'',
            ssemuname:'',
            ssemuinnamecd:'',
            ssver:'',
            sspointkbn:'',
            seq:''
        },
        seq: {seq:''},
        rules: {
            ssid: [
                { required: true, message: '不能为空', trigger: 'blur' },
            ],
            ssaddr: [
                { required: true, message: '不能为空', trigger: 'blur' },
            ],
            ssfilenm: [
                { required: true, message: '不能为空', trigger: 'blur' },
            ],
            ssemuinnamecd: [
                { required: true, message: '不能为空', trigger: 'blur' },
            ],
            // sspointkbn: [
            //     { required: true, message: '不能为空', trigger: 'blur' },
            // ],
        },
        tableData: [],
        btnFlag:false,
        modRadio: '2',
        dialogVisible: false,
        dialogVisible2: false,
        row:{}
    };
  },
  methods: {
    submitForm(formName) {//提交表单
        if (this.modRadio === '2') {
            this.rules.ssemuinnamecd[0].required = true;
            this.ruleForm.sspointkbn = 'emu'
        } else {
            this.rules.ssemuinnamecd[0].required = false;
            if(this.ruleForm.sspointkbn === 'emu') {
                this.ruleForm.sspointkbn = ''
                this.$message({ message: '指向区分emu很特殊，不能从常规模式管理', type: 'error', showClose: true, duration: 1000});
                return 
            }
        }
        this.$refs[formName].validate((valid) => {
            if (valid) {
                let _this = this;
                _this.btnFlag = true;
                this.$axios.post('/ssBaseController/EMUBaseadd.do',{..._this.ruleForm,})
                .then(res => {  //res是返回结果
                    // console.log(res)
                    _this.tableData = res.list;
                        if(res.list){
                            _this.$message({//消息提示框
                            message: '保存成功',
                            type: 'success',
                            showClose: true,//是否有关闭按钮
                            duration: 1000 //持续时间
                        });
                        _this.btnFlag = false;
                    } else {
                        this.dialogVisible = true;
                    }

                })
                .catch(err => { //请求失败就会捕获报错信息
                    _this.btnFlag = false;
                    console.error('服务器连接失败', err);
                    // _this.$message({//消息提示框
                    //     message: '操作失败'+err.message,
                    //     type: 'error',
                    //     showClose: true,//是否有关闭按钮
                    //     duration: 1000 //持续时间
                    // });
                })
            } else {
                console.error('error submit!!');
                return false;
            }
        });
    },
    addToTable(){//把form数据添加到table
        if (this.modRadio === '2') {
            this.ruleForm.sspointkbn = 'emu'
        } else {
            if(this.ruleForm.sspointkbn === 'emu') {
                this.ruleForm.sspointkbn = ''
            }
        }
        let _this = this;
        this.btnFlag = true;
        this.$axios.post('/ssBaseController/EMUBasesearch.do',{..._this.ruleForm,})
        .then(res => {
            if(!res.list.length)
            _this.$message({ message: '没有了', type: 'error', showClose: true, duration: 1000});
            _this.tableData = res.list;
            _this.btnFlag = false;
        })
        .catch(err => {
                    console.error('服务器连接失败', err);
            _this.btnFlag = false;
        });
    },
    resetForm(formName) {//重置表单
        // this.$refs[formName].resetFields();
        for (const key in this.ruleForm) {
            // console.log(formName, key);
            // if (Object.hasOwnProperty.call(object, key)) {
                this.ruleForm[key] = '';
            // }
        }
    },
    openNewWindow(val){//跳转并打开新标签页
        let routeData = this.$router.resolve({
        // const {href} = this.$router.resolve({
            path: val,
            query: {
                ssemuinnamecd:this.ruleForm.ssemuinnamecd,
                ssemuname:this.ruleForm.ssemuname
            },
            // name: val,
            // params:{ :this.ruleForm.ssemuinnamecd}
        });
        window.open(routeData.href, '_blank'); 
        // const {href} = this.$router.resolve({
    },
    handleEdit(index, row) {//修改
        if (this.modRadio === '2') {
            if(row.sspointkbn !== 'emu') {
                this.ruleForm.sspointkbn = ''
                this.$message({ message: '指向区分emu以外的数据，不建议从模拟器模式管理', type: 'error', showClose: true, duration: 1000});
                 
            }
        } else {
            if(row.sspointkbn === 'emu') {
                this.ruleForm.sspointkbn = ''
                this.$message({ message: '指向区分emu的数据，不建议从常规模式管理', type: 'error', showClose: true, duration: 1000});
             
            }
        }

        // console.log(index, row);

        this.ruleForm.ssid = row.ssid;
        this.ruleForm.ssaddr = row.ssaddr;
        this.ruleForm.sskeyw = row.sskeyw;
        this.ruleForm.ssfilenm = row.ssfilenm;
        this.ruleForm.ssfileroad = row.ssfileroad;
        this.ruleForm.ssfilehach = row.ssfilehach;
        this.ruleForm.ssfilesize = row.ssfilesize;
        this.ruleForm.ssfilekeyw = row.ssfilekeyw;
        this.ruleForm.ssbk = row.ssbk;
    
        if (this.modRadio === '2') {
            this.ruleForm.ssemuname = row.ssemuname;
            this.ruleForm.ssemuinnamecd = row.ssemuinnamecd;
            this.ruleForm.ssver = row.ssver;
        } else {
            this.ruleForm.sspointkbn = row.sspointkbn;
        }
    },
    handleDelete(index, row) {//删除
        // console.log(index, row);
        this.row = row;
        this.dialogVisible2 = true;
    },
    ssFormat1(event){//
        var orgStrs = event.split("\n");
        for (var i=0;i<orgStrs.length;i++)
        {
            var items  = orgStrs[i].split(":");
            if(items.length >=2)
            {
                switch (items[0])
                {
                case "文件":
                    var roads = items[items.length - 1].split("\\");
                    // $("#ssfilenm").val(roads[roads.length - 1].trim());
                    this.ruleForm.ssfilenm=roads[roads.length - 1].trim();
                    break;
                case "大小": 
                    // $("#ssfilesize").val(items[1].trim()); break;
                    this.ruleForm.ssfilesize=items[1].trim(); break;
                case "MD5": 
                    this.ruleForm.ssfilehach=items[1].trim();break;
                    // $("#ssfilehach").val(items[1].trim()); break;
                case "CRC32": 
                    // $("#ssid").val(items[1].trim()); break;
                    this.ruleForm.ssid=items[1].trim();break;
                }
            }	
        }
    },
    ssFormat2(event){
        // var orgStr = $("#ssformat2").val();
        var orgStrs = event.split("提取码：");
        if(orgStrs.length === 1) orgStrs = event.split("提取码:");
        if(orgStrs.length >0)
        {
            var partStrs = orgStrs[0].split("链接：");
            if(partStrs.length === 1) partStrs = orgStrs[0].split("链接:");
            this.ruleForm.ssaddr = partStrs[partStrs.length - 1].trim();
            var endStrs = orgStrs[orgStrs.length - 1].split("复")
            this.ruleForm.sskeyw = endStrs[0].trim();
        }
    },
    doupdate() {
        let _this = this;
        this.$axios.post('/ssBaseController/EMUBaseedit.do',{..._this.ruleForm,})
        .then(res => {  //res是返回结果
            _this.tableData = res.list;
            _this.$message({//消息提示框
                            message: '更新成功', type: 'success', showClose: true, duration: 1000});
                            _this.btnFlag = false;
        })
        .catch(err => { //请求失败就会捕获报错信息
            console.error('服务器连接失败', err);
            _this.btnFlag = false;
        });
    },
    dodelete() {
        let _this = this;
        this.btnFlag = true;
        this.ruleForm.ssid = this.row.ssid;
        this.$axios.post('/ssBaseController/EMUBaseDelete.do',{..._this.ruleForm,})
        .then(res => {
            _this.$message({ message: res, type: 'success', showClose: true, duration: 1000});
            setTimeout(() => {
                _this. addToTable()
            }, 1000);
        })
        .catch(err => {
            console.error('服务器连接失败', err);
            _this.btnFlag = false;
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.emuInsert{
  height:100%;
  width:1500px;
  margin: 0 auto;
  display:flex;
  justify-content:left;
  align-items: center;
  text-align: left;
  flex-direction:column;
  
}
.as_btn{
    justify-content: center;
    align-items: center;
}
</style>
